<app-header [loggedUser]="loggedUser!" (toggleSidenav)="drawer.toggle()"></app-header>
<mat-drawer-container class="container" autosize>
  <mat-drawer #drawer class="drawer-side-list" mode="side">
    <mat-nav-list>
      @for (element of sideNavElements; track element) {
        <a mat-list-item [routerLink]="[element.route]" *ngIf="authService.hasAnyRole(element.roles)">
          <mat-icon>{{ element.icon }}</mat-icon>
          {{ element.name }}
        </a>
      }
    </mat-nav-list>
  </mat-drawer>
  <mat-drawer-content class="drawer-content">
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>
